// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-content-background{background-image:none!important}.row.w-100{margin-right:0!important;margin-left:0!important;overflow-x:hidden}.text-title{font-size:20px;color:#212529;font-family:Trebuchet MS,sans-serif}", ""]);
// Exports
module.exports = exports;
